import _ from 'lodash';
import dayjs from 'dayjs';

const FILE_FORMAT = 'DD-MM-YY_HH-MM[s]ss';

/**
 * DateFormatter
 * Helper class for consistent date formatting
 */

const DateFormatter = {
  /**
   * Method: formatUtc
   * Takes a UTC formatted date like `2018-10-17T20:23:46.550Z`
   * and returns `Wed, October 17, 2018, 8:23 PM`
   */
  formatUtc(utcDate) {
    const date = DateFormatter.toDate(utcDate);
    if (!date) return '--';
    const options = {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    return date.toLocaleDateString('en-US', options);
  },

  formatForFile(utcDate) {
    const date = DateFormatter.toDate(utcDate || new Date());
    return dayjs(date).format(FILE_FORMAT);
  },

  formatUtcShort(utcDate) {
    const date = DateFormatter.toDate(utcDate);
    if (!date) return '--';
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };
    return date.toLocaleDateString('en-US', options);
  },

  toDate(utcDate) {
    if (!utcDate || utcDate === '') return false;
    return new Date(utcDate);
  },

  compDate(str1, str2) {
    const d1 = DateFormatter.toDate(str1);
    const d2 = DateFormatter.toDate(str2);
    if (!(d1 && d2)) {
      console.log('compDate: not all dates', d1, d2);
      return 0;
    }
    return _.clamp(d2.getTime() - d1.getTime(), -1, 1);
  },
};

export default DateFormatter;
